<template>
  <div
    class="flex flex-wrap"
    :class="{ 'gap-1': small || xSmall, 'gap-2': !small && !xSmall }"
  >
    <slot></slot>
    <Tag v-for="tag in tags" :small="small" :x-small="xSmall" :tag="tag.id">
      {{ $t(`components.tag.${tag.id}.name`) }}
    </Tag>
    <slot name="postpend"></slot>
  </div>
</template>

<script setup lang="ts">
import type { TagEntity, TagRelation } from "~/src/api";

interface Props {
  tags: (TagEntity | TagRelation)[];
  small?: boolean;
  xSmall?: boolean;
}

const props = defineProps<Props>();
provide("small", props.small);
provide("xSmall", props.xSmall);
</script>

<style scoped></style>
